<template>
    <section class="hero">
       <div class="img_carousel" :style="{backgroundImage: 'url(' + heroImage + ')'}"></div>
        <div class="container">
            <div class="top">
                 <h1>
                    {{title || $store.state.shopInfo.name || "Tutti i menu a tua disposizione."}}
                </h1>
            </div>

            <!--div class="btm search">
                <input type="text" class="mv_search" placeholder="Cerca...">
            </div-->
        </div>
         
    </section>
</template>
<script>

export default {
    computed: {
        heroImage () {
            return this.$store.state.storeGallery.find(x => x.primary) ? './api/Image/Get/' + this.$store.state.storeGallery.find(x => x.primary).id : './hero_placeholder.jpg'
        }
    },
    props: [
        'title'
    ],
}
</script>
<style lang="scss" scoped>

    .hero {
        // background: url('../assets/hero_placeholder.jpg') center right no-repeat;
        background-size: cover;
        color: white;
        text-shadow: 0px 2px 10px rgba(0,0,0,.3);
        position: relative;
        .container {
            position: relative;
            z-index: 1;
            pointer-events: none;
        }
    }  

    .img_carousel {
        height: 100%;
        width: 100%;
        position: absolute;
        background-position: center;
        background-size: cover;
        top:0;
        left: 0;
        /*&:before {
            content: "";
            position: absolute;
            bottom:0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: linear-gradient(to top, white, transparent);
        } */
    }

    .img_slide {
        height: 25vh;
        min-height: 300px;
        max-height: 400px;
        position: relative;
        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
        }
    }

</style>